import { UnitTest } from "../UnitTestClass";
import { DataProcessing } from "../DataprocClass";
import { SCHEMAS } from "../../constants";
/*
⚠️ CTS Stands for "Custom Test Suite"

This type of file contains all the Unit Tests to run for their respective Datasets. The Unit tests are run sequentially within Intra, Inter and Schema Validation functions

*/

const ALLOWED_BATTLECARD_TYPES = ["Primary Team", "Roll-up", "Direct Overlay"];

export const validateBattlecardStructureSchema = (battlecardDataset) => {
  // 1. Check schema
  const bcBuilderValidations = new UnitTest(battlecardDataset);
  const checkSchema = bcBuilderValidations.checkSchema(
    SCHEMAS.battlecardBuilderSchema
  );

  return { checkSchema };
};

export const validateBattlecardStructureIntra = (battlecardDataset) => {
  const bcBuilderValidations = new UnitTest(battlecardDataset);
  const bcBuilderPreProcessing = new DataProcessing(battlecardDataset);
  const duplicatesTest = bcBuilderValidations.checkDuplicates(["Name"]);
  //Prepare Data for DoesExistIn checks :
  // 1. Declare battlecard and parent column values as arrays
  const parentValuesInclNull =
    bcBuilderPreProcessing.extractValuesByProperty("ParentName").column_data;
  const battlecardValues =
    bcBuilderPreProcessing.extractValuesByProperty("Name").column_data;
  // 2. Remove Null values from Parent array in order to check against Battlecard Array
  const parentValues = bcBuilderPreProcessing.filterArray(
    [null, "null", "", undefined],
    parentValuesInclNull
  );
  // 3. Check that All Non-Null Parent Values exist in the Battlecard array
  const existsInTestParent = bcBuilderValidations.checkExistsIn(
    parentValues,
    battlecardValues,
    "Parent"
  );
  // 4. Check that All Battlecard Types are either Roll-Up or Primary Team
  const bcTypesValues =
    bcBuilderPreProcessing.extractValuesByProperty("Type").column_data;
  const existsInTestBcType = bcBuilderValidations.checkExistsIn(
    bcTypesValues,
    ALLOWED_BATTLECARD_TYPES,
    "Type"
  );

  //6. Check that All Parents are not PTs
  // const parentBattlecCardTypes = [];
  // for (const rowIndex in battlecardDataset) {
  //   if (parentValues.includes(battlecardDataset[rowIndex]["Name"])) {
  //     const parentBattlecardType = battlecardDataset[rowIndex].Type;
  //     parentBattlecCardTypes.push(parentBattlecardType);
  //   }
  // }
  // const parentBattleCardTypesIsValid = bcBuilderValidations.checkExistsIn(
  //   parentBattlecCardTypes,
  //   ["Roll-up"],
  //   "Type",
  //   true
  // );

  return {
    duplicatesTest,
    existsInTestParent,
    existsInTestBcType,
    // parentBattleCardTypesIsValid,
  };
};
